<template>
  <application-layout>
    <v-container>
      <h1 class="mb-4">Find A Facility</h1>
      <facility-list :type="type" />
    </v-container>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout";
import FacilityList from "@/components/FacilityList";

export default {
  data() {
    return {
      type: "national"
    };
  },

  components: {
    ApplicationLayout,
    FacilityList
  }
};
</script>
